import axios from "axios";
import countriesCodes from "./Pages/countryCodes";

const api = axios.create({
    baseURL: import.meta.env.VITE_BASE_API_URL,
});

const getCoursesApi = (data) => {
    const url = "/web/wellness-library/courses/list";
    return api.get(url, data);
};

const getCourseContentById = (courseId) => {
    const url = `/web/wellness-library/courses/show/${courseId}`;
    return api.get(url);
};

/** Local country list — restcountries v3+ is deprecated and v5 requires an API key. */
const getCountries = () =>
    Promise.resolve({data: buildCountriesFromCodes(countriesCodes)});

export function getFlagEmoji(isoCode) {
    if (!isoCode || isoCode.length !== 2) return "";
    return String.fromCodePoint(
        ...[...isoCode.toUpperCase()].map((char) => 0x1f1e6 + char.charCodeAt(0) - 65)
    );
}

/** @deprecated External flag images are blocked by COEP; use getFlagEmoji instead. */
export function getFlagUrl(isoCode) {
    if (!isoCode) return "";
    return `https://flagcdn.com/w40/${isoCode.toLowerCase()}.png`;
}

export function buildCountriesFromCodes(codes) {
    return [...codes]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((c) => ({
            name: {common: c.name},
            flags: {png: ""},
            demonyms: {eng: {f: c.name, m: c.name}},
            isoCode: c.code,
        }));
}

export function buildNationalityOptions(codes = countriesCodes) {
    return buildCountriesFromCodes(codes).map((country) => ({
        name: country.demonyms?.eng?.f || country.name.common,
        flag: getFlagEmoji(country.isoCode),
        isoCode: country.isoCode,
    }));
}

const getCountriesCodes = () =>
    Promise.resolve({data: buildCountriesFromCodes(countriesCodes)});

const fetchTermsAndConditions = (data) => {
    const url = "/web/terms-and-conditions";
    return api.get(url, data);
};

const fetchPrivacyPolicy = (data) => {
    const url = "/web/privacy-policies";
    return api.get(url, data);
};

const submitContact = (data) => {
    const url = "/web/contact-us";
    return api.post(url, data);
};

const submitTherapistSignup = (data) => {
    const url = "/auth/therapy-register";
    return api.post(url, data);
}

const submitPartnerForm = (data) => {
    const url = "/partner/request";
    return api.post(url, data);
}


const checkEmail = (data) => {
    const url = "/auth/login/preview";
    return api.post(url, data);
};
const checkOtp = (data) => {
    const url = "/auth/otp/request";
    return api.post(url, data);
};
const checkPhoneNumber = (data) => {
    const url = "/general/location/country-phone-numbers";
    return api.get(url, data);
};

const fetchTestimonialsApi = () => {
    const url = "/web/reviews";
    return api.get(url);
};

export {
    getCoursesApi,
    getCourseContentById,
    fetchTermsAndConditions,
    fetchPrivacyPolicy,
    submitContact,
    fetchTestimonialsApi,
    getCountries,
    submitTherapistSignup,
    getCountriesCodes,
    checkEmail,
    checkPhoneNumber,
    checkOtp,
    submitPartnerForm
};
export default api;
